module.exports = __webpack_public_path__ + "static/media/apptnext.4482e7f8.svg";